import { IElevioEvents, ElevioEvents } from './events';
import { BaseEvent } from './types';
import getSender, { promiseSender } from './sender';
import Batch from './batch';
import { getAll } from './pageStats';

export { getSender, BaseEvent, Batch, ElevioEvents, getAll };

/**
 * Batcher is responsible for dealing with the queue of events and flushing them
 * to the thing that sends it to the backend (see sender.ts)
 */
export interface Batcher {
  addEvent: (event: IElevioEvents) => void;
  flush: (isSync: boolean) => void;
}
let _batch: Batcher | undefined;

export function setBatcher(batch: Batcher) {
  _batch = batch;
}
export function getBatcher(): Batcher | undefined {
  return _batch;
}

/**
 * Config allows configuring of the events.
 * isDisabled will prevent events being added to batcher
 * isAnonMode will strip sensitive info from events.
 */
export interface Config {
  // type: string; //  type: 'web-sdk-event',
  isDisabled?: boolean;
  isAnonMode?: boolean;
}
let _config: Config | undefined;
export function setConfig(config: Config) {
  _config = config;
}
export function getConfig(): Config | undefined {
  return _config;
}

/**
 * EventFlesher is what fills out all the base level details about an event.
 * This will be different per project so you can define which stores data comes from.
 */
export type EventFlesher = () => BaseEvent;

let _flesher: EventFlesher | undefined;

export function setFlesher(flesher: EventFlesher) {
  _flesher = flesher;
}

export function getFlesher(): EventFlesher | undefined {
  return _flesher;
}

/**
 * This is the thing that adds the event to the dispatch queue.
 */
function track(event: IElevioEvents) {
  if (!_batch) throw new Error("Batcher hasn't been set yet");
  if (!_config) throw new Error("Config hasn't been set yet");
  if (_config.isDisabled) return;

  // So we can change the event without modifying the original
  let myEvent = { ...event };

  if (_config.isAnonMode) {
    delete myEvent.page_url;
    delete myEvent.page_referrer;
    delete myEvent.user_id_external;
  }

  if (typeof myEvent.custom_attributes === 'object') {
    myEvent.custom_attributes = JSON.stringify(myEvent.custom_attributes);
  }

  _batch.addEvent(myEvent);
}

export default track;

/**
 * This sends the events without using the batching q.
 * It returns a promise so you can wait for it and will throw an error if it fails.
 * @param events the array of events to send.
 */
export function sendNow(events: Array<IElevioEvents>): Promise<void> {
  if (!_config) throw new Error("Config hasn't been set yet");
  return promiseSender(events);
}
